export default __webpack_public_path__ + "static/media/search.baaf14a5.svg";